module.exports = __webpack_public_path__ + "static/media/recarga.055d62cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/recarga.png
// module id = 254
// module chunks = 0